import React from 'react';
import { Zap, Users, BarChart3, PhoneCall, Globe } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';



const features = [
  { id: 'feat-ai', icon: Zap, text: 'AI Receptionist answers calls 24/7' },
  { id: 'feat-leads', icon: Users, text: 'Capture and qualify leads automatically' },
  { id: 'feat-analytics', icon: BarChart3, text: 'Real-time marketing analytics dashboard' },
  { id: 'feat-calls', icon: PhoneCall, text: 'Never miss a customer call again' },
  { id: 'feat-website', icon: Globe, text: 'Build and publish websites in minutes' },
];

const stats = [
  { id: 'stat-leads', value: '12,400+', label: 'Leads Captured' },
  { id: 'stat-clients', value: '840+', label: 'Active Businesses' },
  { id: 'stat-uptime', value: '99.9%', label: 'Platform Uptime' },
];

export default function BrandPanel() {
  return (
    <div className="hidden lg:flex w-[520px] xl:w-[580px] 2xl:w-[640px] shrink-0 gradient-brand flex-col justify-between p-10 xl:p-12 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-80 h-80 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2 pointer-events-none" />
      {/* Top: Logo + tagline */}
      <div className="relative z-10">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-2xl bg-white/15 backdrop-blur-sm flex items-center justify-center border border-white/20">
            <span className="text-white font-extrabold text-lg">MBS</span>
          </div>
          <div>
            <p className="text-white font-bold text-lg leading-tight">Marketing Biz Solutions</p>
            <p className="text-blue-200 text-sm">AI Platform</p>
          </div>
        </div>

        <h1 className="text-3xl xl:text-4xl font-extrabold text-white leading-tight mb-4">
          Grow your business with{' '}
          <span className="text-yellow-300">AI-powered</span>{' '}
          marketing
        </h1>
        <p className="text-blue-100 text-base leading-relaxed mb-8">
          The all-in-one platform that replaces 8 tools. Manage leads, run campaigns, and let AI handle customer conversations — all from one dashboard.
        </p>

        {/* Features list */}
        <div className="space-y-3">
          {features?.map((f) => {
            const Icon = f?.icon;
            return (
              <div key={f?.id} className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-white/15 flex items-center justify-center shrink-0">
                  <Icon size={16} className="text-yellow-300" />
                </div>
                <span className="text-blue-50 text-sm font-medium">{f?.text}</span>
              </div>
            );
          })}
        </div>
      </div>
      {/* Bottom: Stats */}
      <div className="relative z-10">
        <div className="grid grid-cols-3 gap-4 bg-white/10 backdrop-blur-sm rounded-2xl p-5 border border-white/15">
          {stats?.map((s) => (
            <div key={s?.id} className="text-center">
              <p className="text-2xl font-extrabold text-white font-mono">{s?.value}</p>
              <p className="text-blue-200 text-xs mt-0.5">{s?.label}</p>
            </div>
          ))}
        </div>
        <p className="text-blue-300 text-xs text-center mt-4">
          Trusted by businesses across the United States
        </p>
      </div>
    </div>
  );
}